import React from 'react';

export const StatsCards = ({ stats, items }) => (
  <section className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="admin-stats">
    {items.map(({ key, label, icon: Icon, color }) => (
      <div key={key} data-testid={`admin-stat-${key}`} className="bg-white/5 border border-white/10 rounded-2xl p-4 sm:p-5 flex items-center gap-3 sm:gap-4">
        <div className={`h-10 w-10 sm:h-12 sm:w-12 shrink-0 rounded-xl bg-gradient-to-br ${color} flex items-center justify-center shadow-lg`}>
          <Icon className="h-5 w-5 sm:h-6 sm:w-6 text-white" />
        </div>
        <div className="min-w-0">
          <p className="text-2xl sm:text-3xl font-bold leading-none">{stats ? stats[key] ?? 0 : '—'}</p>
          <p className="text-slate-400 text-xs sm:text-sm mt-1 truncate">{label}</p>
        </div>
      </div>
    ))}
  </section>
);

export default StatsCards;
